import axios from "axios";
import swal from "sweetalert";
import config from "../../config.json";

export const fetchUserNotifications = async () => {
  try {
    const res = await axios.get(
      `${config.dev}/v2/notification/user-notifications`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data; // { notifications, unreadCount }
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const functionMarkAsRead = async (notificationId) => {
  try {
    const res = await axios.put(
      `${config.dev}/v2/notification/update-status/${notificationId}`
    );
    return res.data;
  } catch (error) {
    console.error("Error updating notifications:", error);
    throw error;
  }
};
